function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useEffect, useState } from 'react';
import withRender from '../../hoc/withRender';
import { useDispatch, useSelector } from 'react-redux';
import NavitiaSuggestionsComponent from '../../components/NavitiaSearch/NavitiaSuggestions';
import { navitiaSearch } from '../../store/actions/navitiaSearch';
var NavitiaSuggestions = function NavitiaSuggestions(props) {
  var dispatch = useDispatch();
  var _useSelector = useSelector(function (state) {
      var _state$dataset;
      return state === null || state === void 0 ? void 0 : (_state$dataset = state.dataset) === null || _state$dataset === void 0 ? void 0 : _state$dataset.navitiaSearch;
    }),
    suggestions = _useSelector.suggestions,
    loading = _useSelector.loading;
  var handleSearch = function handleSearch(value) {
    dispatch(navitiaSearch(value));
  };
  return /*#__PURE__*/React.createElement(NavitiaSuggestionsComponent, _extends({
    suggestions: suggestions,
    loading: loading,
    onSelect: function onSelect(value) {
      return handleSearch(value);
    }
  }, props));
};
export default withRender(NavitiaSuggestions);